
      var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInternetOrderSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 152,
  height: 86,
  viewBox: "0 0 152 86",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 5)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 19.254,
  y: 1,
  width: 89.268,
  height: 60.746,
  rx: 2.423,
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "m109.025 58.042 13.766 18.068c1.215 1.594.078 3.89-1.927 3.89H6.91c-2.004 0-3.141-2.296-1.927-3.89L18.75 58.042h90.276Z",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "m108.252 58.042 12.676 14.52c1.367 1.567.254 4.016-1.825 4.016H8.672c-2.08 0-3.193-2.449-1.825-4.016l12.676-14.52h88.729Z",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("mask", {
  id: "internet-order-success_f8bec51dc64a2836__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  x: 22.816,
  y: 4.563,
  width: 82.141,
  height: 54.761,
  rx: 1.141
})), /*#__PURE__*/React.createElement("rect", {
  x: 22.816,
  y: 4.563,
  width: 82.141,
  height: 54.761,
  rx: 1.141,
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 4,
  mask: "url(#internet-order-success_f8bec51dc64a2836__a)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M79.632 20.346c-.11.252-.162.498-.303.669-.323.389-.656.781-1.044 1.1-1.123.925-2.276 1.81-3.413 2.718-.923.735-1.854 1.464-2.642 2.352a10.16 10.16 0 0 0-.85 1.109c-.294.44-.302.908-.092 1.412.493 1.184 1.1 2.307 1.723 3.423 1.719 3.085 3.383 6.2 4.915 9.384.284.59.477 1.225.71 1.84a.744.744 0 0 1 .043.202c.028.336-.125.53-.45.466-.356-.07-.723-.18-1.036-.36a43.81 43.81 0 0 1-2.268-1.412c-2.404-1.583-4.8-3.179-7.201-4.766-.973-.643-1.975-1.236-3.053-1.686-.82-.342-1.665-.53-2.56-.452-.678.06-1.305.281-1.912.575-1.091.53-2.072 1.233-3.036 1.96-1.927 1.454-3.838 2.93-5.762 4.387-.415.314-.853.598-1.289.883-.17.111-.357.209-.548.277-.297.105-.5-.05-.454-.363.036-.256.113-.51.208-.751.508-1.292 1.01-2.586 1.548-3.865.864-2.051 1.763-4.088 2.63-6.137.31-.734.576-1.484.738-2.27.188-.915-.066-1.639-.84-2.15-.434-.285-.896-.528-1.348-.784-.322-.182-.652-.35-.973-.533a4.472 4.472 0 0 1-.514-.34c-.515-.4-.487-.882.103-1.151.67-.306 1.36-.578 2.055-.822 1.07-.376 2.155-.71 3.23-1.075.4-.137.788-.31 1.181-.468a5.023 5.023 0 0 0 2.396-1.999c.578-.9 1.083-1.848 1.633-2.767.261-.435.527-.873.843-1.267.18-.225.447-.41.711-.532.501-.232.86-.127 1.193.314.214.284.392.597.575.903.338.566.658 1.143 1.005 1.703a1.97 1.97 0 0 0 1.35.931c.374.07.766.127 1.14.09a83.175 83.175 0 0 0 3.581-.433c1.867-.267 3.727-.577 5.595-.835.511-.071 1.039-.042 1.557-.024.211.007.435.078.622.177.126.067.199.234.303.367Z",
  fill: "var(--theme-primary, #810EA9)"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(99)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 17.23C0 7.715 7.714 0 17.23 0h18.11c9.517 0 17.231 7.714 17.231 17.23v36.616c0 1.19-.964 2.154-2.153 2.154H2.154A2.154 2.154 0 0 1 0 53.846V17.231Z",
  fill: "var(--theme-primary, #810EA9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.858 22.857s-5.016-4.571-12.572-4.571c-7.556 0-12.571 4.571-12.571 4.571M33.144 28.571s-2.736-2.285-6.857-2.285c-4.122 0-6.857 2.285-6.857 2.285",
  stroke: "#fff",
  strokeWidth: 4.571,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26.286,
  cy: 34.286,
  r: 1.714,
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1.143
}))));

      const __svgRaw = "<svg width=\"152\" height=\"86\" viewBox=\"0 0 152 86\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g transform=\"translate(0, 5)\">\r\n<rect x=\"19.2539\" y=\"1\" width=\"89.2676\" height=\"60.7465\" rx=\"2.42254\" fill=\"white\" stroke=\"black\" stroke-width=\"2\"/>\r\n<path d=\"M109.025 58.0425L122.791 76.1099C124.006 77.7045 122.869 80.0005 120.864 80.0005H6.91016C4.90565 80.0003 3.76876 77.7044 4.9834 76.1099L18.749 58.0425H109.025Z\" fill=\"white\" stroke=\"black\" stroke-width=\"2\"/>\r\n<path d=\"M108.252 58.0425L120.928 72.562C122.295 74.1289 121.182 76.5775 119.103 76.5776H8.67188C6.59188 76.5776 5.4789 74.129 6.84668 72.562L19.5225 58.0425H108.252Z\" fill=\"white\" stroke=\"black\" stroke-width=\"2\"/>\r\n<mask id=\"internet-order-success-screen\" fill=\"white\">\r\n<rect x=\"22.8164\" y=\"4.56348\" width=\"82.1408\" height=\"54.7606\" rx=\"1.14085\"/>\r\n</mask>\r\n<rect x=\"22.8164\" y=\"4.56348\" width=\"82.1408\" height=\"54.7606\" rx=\"1.14085\" fill=\"white\" stroke=\"black\" stroke-width=\"4\" mask=\"url(#internet-order-success-screen)\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M79.6324 20.3458C79.522 20.5982 79.4702 20.8441 79.3288 21.0147C79.0063 21.4036 78.6725 21.7962 78.2849 22.1155C77.1625 23.0397 76.0087 23.9257 74.8718 24.8325C73.9493 25.5684 73.018 26.2971 72.2303 27.1845C71.922 27.5322 71.6376 27.9063 71.3798 28.2936C71.0862 28.7349 71.0776 29.2018 71.2876 29.7064C71.7806 30.8902 72.3887 32.0126 73.0106 33.1288C74.7297 36.2139 76.3937 39.3287 77.9255 42.5127C78.2096 43.1034 78.4035 43.7379 78.6365 44.3535C78.6606 44.417 78.6737 44.4866 78.6793 44.5547C78.7073 44.8912 78.5541 45.0851 78.2287 45.021C77.8726 44.9511 77.5059 44.841 77.1931 44.6611C76.4215 44.2179 75.669 43.7392 74.9253 43.2494C72.521 41.6663 70.1255 40.07 67.7237 38.4832C66.7508 37.8404 65.7494 37.2473 64.6711 36.7972C63.8519 36.4552 63.0061 36.2668 62.1115 36.3449C61.4329 36.4043 60.8055 36.6262 60.1986 36.9204C59.1078 37.4492 58.1266 38.1532 57.1634 38.8799C55.2363 40.3342 53.325 41.8092 51.4007 43.267C50.9861 43.5813 50.5476 43.8648 50.1122 44.1499C49.9414 44.2615 49.7553 44.3587 49.5638 44.4269C49.2671 44.5325 49.0649 44.3765 49.1097 44.0639C49.1463 43.8084 49.2233 43.5535 49.318 43.3127C49.8262 42.0214 50.3274 40.7268 50.8658 39.4482C51.7296 37.3969 52.6287 35.3603 53.4966 33.3106C53.8069 32.5774 54.072 31.8273 54.2338 31.0401C54.422 30.1258 54.1682 29.4021 53.3936 28.8916C52.9599 28.6058 52.498 28.3629 52.0457 28.1068C51.7239 27.9246 51.3936 27.7578 51.073 27.5739C50.8952 27.4718 50.7216 27.3588 50.5595 27.2331C50.0437 26.8338 50.0722 26.3518 50.6622 26.0826C51.3327 25.7768 52.0213 25.5053 52.7165 25.2608C53.7869 24.8847 54.8719 24.5509 55.9461 24.1855C56.3465 24.0493 56.7348 23.8762 57.1281 23.7184C58.1411 23.3124 58.9411 22.6297 59.5243 21.7194C60.1016 20.8183 60.6069 19.8708 61.1574 18.9519C61.4181 18.5167 61.6835 18.0788 61.9998 17.685C62.1805 17.4597 62.4468 17.2751 62.7113 17.1528C63.2124 16.9213 63.5718 17.0258 63.904 17.4671C64.1178 17.7511 64.2956 18.0638 64.4789 18.37C64.8172 18.9358 65.1373 19.5132 65.4842 20.0734C65.796 20.5763 66.2568 20.8975 66.8339 21.0043C67.208 21.0735 67.6 21.1313 67.974 21.0945C69.1704 20.9763 70.3649 20.8307 71.5552 20.6607C73.4219 20.3941 75.2825 20.0844 77.1502 19.8257C77.6612 19.755 78.1888 19.7836 78.7075 19.8018C78.9183 19.8093 79.1416 19.8797 79.3293 19.979C79.455 20.0455 79.5279 20.2132 79.6324 20.3458Z\" fill=\"var(--theme-primary, #810EA9)\"/>\r\n</g>\r\n<g transform=\"translate(99, 0)\">\r\n<path d=\"M0 17.2308C0 7.71448 7.71448 0 17.2308 0H35.3407C44.8569 0 52.5714 7.71448 52.5714 17.2308V53.8462C52.5714 55.0357 51.6071 56 50.4176 56H2.15385C0.96431 56 0 55.0357 0 53.8462V17.2308Z\" fill=\"var(--theme-primary, #810EA9)\"/>\r\n<path d=\"M38.8577 22.8571C38.8577 22.8571 33.8423 18.2856 26.2863 18.2856C18.7302 18.2856 13.7148 22.8571 13.7148 22.8571\" stroke=\"white\" stroke-width=\"4.57143\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M33.144 28.5714C33.144 28.5714 30.4083 26.2856 26.2868 26.2856C22.1653 26.2856 19.4297 28.5714 19.4297 28.5714\" stroke=\"white\" stroke-width=\"4.57143\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<circle cx=\"26.2857\" cy=\"34.2857\" r=\"1.71429\" fill=\"white\" stroke=\"white\" stroke-width=\"1.14286\"/>\r\n</g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/internet-order-success.f8bec51dc64a2836bf0add4d824eeac8.svg"),
        {
          React: SvgInternetOrderSuccess,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      